
import { Table, Stack, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Divider, Grid, Typography, Tooltip, Autocomplete, TextField, InputAdornment, useTheme, Button, Toolbar } from "@mui/material";

import { styled } from '@mui/material/styles';

import React, { useState, useEffect, useRef } from "react";
import Cancel from '@mui/icons-material/CancelOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import PropTypes from 'prop-types';
import Header from "../../../Layout/Header";


import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';


import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import CallAlertBar from "../../../Layout/Alertbar";

import SaveAltIcon from '@mui/icons-material/SaveAlt';

import useDepartment from "../../../hooks/useDepartment";
import useRequestIndentNumberListByDepartment from "../../../hooks/useRequestIndentNumberByDepartmentID";
import useLoadIssueDetailByRequestNumber from "../../../hooks/useLoadIssueIndentDetailByRequestIndent";
import useIssuedIndentNumber from "../../../hooks/useIssuedIndentNumber";
import useIssuedIndentCRUD from "../../../hooks/useIssuedIndentCRUD";
import useEmployee from "../../../hooks/useEmployee";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import IssueIndentActionMenu from "./IssueIndentSubMenu";
import CreateIcon from '@mui/icons-material/Create';
import AddNewPurchaseIndent from "../../purchase/purchase-indent/AddNewPurchaseIndent";
import AmentApproveRequest from "../../../Layout/Ament-Approve-Request";
import { tokens } from "../../../theme/theme";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}





const AddNewIssue = ({ handlecallback, editIssueIndentID, selectedMode, SelectedDepartmentID, SelectedRequestID }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Parent Roll  Alert Values
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
  const [viewPurchaseIndent, setViewPurchaseIndent] = useState(false);
  const [viewPurchaseIndentPage, setViewPurchaseIndentPage] = useState(false);

  const callMessage = (serverityval, msg, title) => {
    setParentRollSeverityvalue(serverityval);
    setParentRollMessageValue(msg);
    setParentRollAlertTitleValue(title);
    setParentRollMsgOpen(true);
  };

  //pop-up
  const [openChildRollList, setOpenChildRollList] = useState(false);

  // List of Parameter
  const [customerNotes, setCustomerNotes] = useState('');
  const [issuedDate, setIssuedDate] = useState(dayjs());
  const [tableRows, setTableRows] = useState([{ id_request_det: 1, material_code: '', material_description: '', quantity_approved: 0, quantity_issued: 0, quantity_balance: 0, quantity_to_issue: 0, purchase_indent_number: '' }]);


  // get party list
  const [selectedButtonName, setSelectedButtonName] = useState('');
  const { department, selectedDepartment, selectedDepartmentID, setSelectedDepartment, setSelectedDepartmentID, loadDepartmentByID } = useDepartment(0);
  const { requestIndentNumberList, selectedRequestIndentNumberList, selectedRequestIndentNumberListID, setSelectedRequestIndentNumberList, setSelectedRequestIndentNumberListID, loadIndentNumbersByDepartmentID } = useRequestIndentNumberListByDepartment(0);
  const { RequestIndentDetail, loadIssueDetailByRequestIndentID, } = useLoadIssueDetailByRequestNumber();
  const { issuedIndentNumber, setIssuedIndentNumber, loadIssuedIndentNumberByID } = useIssuedIndentNumber(0);
  const { employee, selectedEmployee, selectedEmployeeID, setSelectedEmployee, setSelectedEmployeeID, loadEmployeeByID, } = useEmployee(editIssueIndentID);
  const { processIndent } = useIssuedIndentCRUD(callMessage);

  const [editMode, setEditMode] = useState(false);

  const callback = () => {
    handlecallback();
  }

  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
  ))({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: colors.blueAccent[500],
      color: 'white',
      fontSize: '14px',
      borderRadius: '10px',
      padding: '10px',

    },
    [`& .MuiTooltip-arrow`]: {
      color: colors.blueAccent[500],
    },
  });

  const [isLoadEditPO, setLoadEditPO] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(false);

  useEffect(() => {
    if (RequestIndentDetail && RequestIndentDetail?.length > 0) {
      setTableRows(RequestIndentDetail);
      if (RequestIndentDetail[0]?.purchase_indent_number) {

        callMessage('warning', `Purchase Indent already created against the purchase indent no : ${RequestIndentDetail[0]?.purchase_indent_number}`, 'Warning');

      }

      setSaveDisabled(false);
      setParentRollMsgOpen(false);
    }
    else {
      setTableRows([]);

      //       // Disable save button if all quantity_to_issue are 0
      // const isAllIssueZero = RequestIndentDetail.every(item => item.quantity_to_issue === 0);

      // Example: disabling a save button (if using a state variable)
      if (selectedRequestIndentNumberList.request_indent_number) {
        setSaveDisabled(true); // assumes you have a state variable like [saveDisabled, setSaveDisabled]

        callMessage('info', 'No items found (or) quantity already issued for the selected request indent number.', 'Info');

      }

    }

  }, [RequestIndentDetail])

  useEffect(() => {

    if (!isLoadEditPO && editIssueIndentID !== 0) {
      setEditMode(true);
      try {
        const fetchData = async () => {

          const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_issue: editIssueIndentID,
          };

          const purchaseOrderResponse = await callApi(API_ENDPOINTS.ISSUED_INDENT_GET_DETAIL_BY_ID, 'POST', { 'Content-Type': 'application/json' }, para);
          const purchaseOrder = purchaseOrderResponse[0];

          if (purchaseOrder) {
            setIssuedIndentNumber(purchaseOrder.issue_indent_number);
            setIssuedDate(purchaseOrder.issue_date);

            await loadEmployeeByID(purchaseOrder.id_issuer);
            await loadDepartmentByID(purchaseOrder.id_department);
            await loadIssueDetailByRequestIndentID(purchaseOrder.id_request, purchaseOrder.issue_indent_number);
            await loadIndentNumbersByDepartmentID(purchaseOrder.id_department, 'issue indent', purchaseOrder.id_request)

          }
        };

        fetchData();
      } catch (error) {
        callMessage('error', error.message, 'Error');
      }
    }

  }, [isLoadEditPO, editIssueIndentID]);



  const getRequestDetailByRequestID = async (id_request) => {
    await loadIssueDetailByRequestIndentID(id_request, '');
  }

  const handleQuantityChange = (index, quantity) => {
    setTableRows((prevRows) => {
      return prevRows.map((row, i) => {
        if (i === index) {
          return row.quantity_balance < quantity
            ? row  // Return unchanged row if condition is not met
            : { ...row, quantity_to_issue: quantity }; // Create a new object for state change detection
        }
        return row;
      });
    });
  };


  const handleSaveAndDraft = async () => {
    // const handleSaveAndDraft = () => {

    const modifiedRows = tableRows.map(({ material_code, material_description, ...rest }) => rest);

    if (RequestIndentDetail[0]?.purchase_indent_number) {
      // Validate that no row has quantity_to_issue > quantity_available
      const invalidRow = modifiedRows.find(row => row.quantity_to_issue > row.quantity_available);

      // if (invalidRow) {
      //   callMessage(
      //     'warning',
      //     `Quantity to issue cannot exceed the available quantity, as this request indent has already been created as a purchase indent.`,
      //     'Validation Error'
      //   );
      //   return;
      // }
    }

    if (selectedDepartmentID === 0 || !selectedDepartmentID) {
      callMessage(
        'warning',
        'Please select the department.',
        'Validation'
      );
      return;
    }

    if (selectedRequestIndentNumberListID === 0 || !selectedRequestIndentNumberListID) {
      callMessage(
        'warning',
        'Please select the request indent number.',
        'Validation'
      );
      return;
    }

    if (selectedEmployeeID === 0 || !selectedEmployeeID) {
      callMessage(
        'warning',
        'Please select an issuer before saving the issue indent.',
        'Validation'
      );
      return;
    }
    if (!issuedDate || issuedDate === null) {

      callMessage(
        'warning',
        'Please select the issue date.',
        'Validation'
      );
      return;
    }

    if (modifiedRows.length === 0 || modifiedRows[0].id_material === 0) {
      callMessage('warning', 'At least one item is required in the Issue indent', 'Validation');
      return;
    }


    const hasZeroQty = modifiedRows.some(row => Number(row.quantity_to_issue) === 0);

    if (hasZeroQty) {
      callMessage(
        'warning',
        'Issue quantity must be greater than 0 for all items',
        'Validation'
      );
      return;
    }





    let mode_id = 0;
    if (editIssueIndentID != 0) {
      mode_id = 1;
    }
    let id_request = editIssueIndentID !== 0 ? editIssueIndentID : 0;

    // Items with ZERO stock → for Purchase Indent
    const zeroStockItems = modifiedRows.filter(
      item => item.quantity_available === 0
    );

    // Items eligible for issue
    const issueItems = modifiedRows.filter(
      item => item.quantity_available > 0
    );


    const isLowStock = issueItems.some(
      item => item.quantity_available < item.quantity_to_issue
    );

    if (isLowStock) {
      callMessage(
        'warning',
        'One or more items have insufficient stock. Reduce the issue quantity.',
        'Warning'
      );
      return;
    }
    if (issueItems.length === 0) {
      callMessage(
        'warning',
        'No items available for issue. All selected items have zero stock. Please Create a Purchase Indent',
        'Validation'
      );

      setViewPurchaseIndent(true);
      return;
      
    }


    const requestBody = {
      p_companyid: localStorage.getItem('companyid'),
      p_plantid: 1,
      p_id_issue: id_request,
      p_id_request: selectedRequestIndentNumberListID,
      p_mode: mode_id,
      p_id_issuer: selectedEmployeeID,
      p_id_department: selectedDepartmentID,
      p_issue_indent_number: issuedIndentNumber,
      p_issue_date: dayjs(issuedDate).format('YYYY-MM-DD hh:mm:ss'),
      p_status: 'Issued',
      //p_issueitem_list: modifiedRows,
      p_issueitem_list: issueItems

    }

    // // Check if any item fails the condition
    // const isLowStock = modifiedRows.some(
    //   (item) => item.quantity_available < item.quantity_to_issue
    // );

    // if (isLowStock) {
    //   callMessage('warning', 'One or more items have insufficient stock. Please Create a Purchase Indent', 'Warning');
    //   setViewPurchaseIndent(true);
    //   return;
    // }




    // processIndent(selectedMode, editIssueIndentID, requestBody);
    const isSuccess = await processIndent(
      selectedMode,
      editIssueIndentID,
      requestBody
    );

    if (isSuccess) {
      setSaveDisabled(true); // ✅ Disable Issue button only on success
    }

  };

  const handleCreatePurchaseIndent = () => {
    setViewPurchaseIndentPage(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      await loadDepartmentByID(SelectedDepartmentID);
      await loadIndentNumbersByDepartmentID(SelectedDepartmentID, 'issue indent', SelectedRequestID);
    };

    if (SelectedDepartmentID && SelectedRequestID) {
      fetchData();
    }
  }, [SelectedDepartmentID, SelectedRequestID]);


  useEffect(() => {
    getRequestDetailByRequestID(SelectedRequestID);
  }, [SelectedRequestID]);


  const closeChildRollList = () => {
    setOpenChildRollList(false);
  };


  return (<>

    {!viewPurchaseIndentPage && (
      <Box padding={0}>

        <Header title={editIssueIndentID == 0 ? 'New Indent Issue' : 'Edit Indent Issue'} subtitle="" callback={callback} />
        <Divider />
        {editIssueIndentID > 0 && (
          <>
            <IssueIndentActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} />
            <Divider />
          </>
        )}

        <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
          setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
          setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />



        <AmentApproveRequest open={openChildRollList} onClose={closeChildRollList} />

        <Box
          sx={{
            padding: "5px",
            borderRadius: "10px",
            maxHeight: {
              xs: '72vh', // Extra small devices (phones)
              sm: '72vh', // Small devices (tablets)
              md: '74vh', // Medium devices (small laptops)
              lg: '74vh', // Large devices (desktops)
              xl: '82vh', // Extra large devices (large desktops)
            },
            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              background: colors.primary[400],
              borderRadius: '10px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: colors.blueAccent[600],
              borderRadius: '10px',
              '&:hover': {
                background: colors.blueAccent[800],
              },
            },
            '&::-webkit-scrollbar-corner': {
              background: colors.primary[700],
            }
          }}>

          <Grid container  >

            <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ backgroundColor: colors.primary[400] }}  >
              <Grid
                container
                padding="10px 20px"
                spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                alignItems="center"
                justifyContent="space-between"
              >
                {/* LEFT SIDE */}
                <Grid item>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item mr={4}>
                      <Typography variant="h6" fontSize={14}>
                        Issue Slip No# <span style={{ color: 'red' }}>*</span>
                      </Typography>
                    </Grid>

                    <Grid item>
                      <TextField
                        value={issuedIndentNumber}
                        size="small"
                        required
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="start">
                              <CustomTooltip title="Click here to enable or disable auto generation of purchase order number.">
                                <SettingsIcon sx={{ fontSize: 20 }} />
                              </CustomTooltip>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* RIGHT SIDE */}
                <Grid item>
                  <Typography variant="h6">
                    <span style={{ color: 'red' }}>*</span> Mandatory fields
                  </Typography>
                </Grid>
              </Grid>




            </Grid>

            <Grid item xs={12} xl={12} >

              <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Department <span style={{ color: 'red' }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    options={department}
                    value={selectedDepartment}
                    disabled={editMode}
                    onChange={(event, newValue) => {
                      setSelectedDepartment(newValue);
                      setSelectedDepartmentID(newValue.id);
                      loadIndentNumbersByDepartmentID(newValue.id, 'issue indent');
                    }}
                    getOptionLabel={(option) => option.description || ''}
                    renderInput={(params) => (
                      <TextField {...params} label="" required variant="outlined" />
                    )}
                  />
                </Grid>
              </Grid>

              <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                  <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Request Indent # <span style={{ color: 'red' }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>

                  <Autocomplete
                    size="small"
                    fullWidth
                    options={requestIndentNumberList}
                    value={selectedRequestIndentNumberList}
                    disabled={editMode}
                    onChange={(event, newValue) => {
                      setSelectedRequestIndentNumberList(newValue);
                      setSelectedRequestIndentNumberListID(newValue.id_request);
                      getRequestDetailByRequestID(newValue.id_request);
                    }}
                    getOptionLabel={(option) => option.request_indent_number || ''}
                    renderInput={(params) => (
                      <TextField {...params} label="" required variant="outlined" />
                    )}
                  />
                </Grid>


              </Grid>
            </Grid>

            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Issued By <span style={{ color: 'red' }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    options={employee}
                    value={selectedEmployee}
                    onChange={(event, newValue) => {
                      setSelectedEmployee(newValue);
                      setSelectedEmployeeID(newValue.id);

                    }}
                    getOptionLabel={(option) => option.name || ''}
                    renderInput={(params) => (
                      <TextField {...params} label="" required variant="outlined" />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Issue Date <span style={{ color: 'red' }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2} xl={1.5}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack spacing={2}>
                      <DatePicker
                        size="small"
                        id="Orderdate"
                        format="DD-MMM-YYYY"
                        value={dayjs(issuedDate)}
                        onChange={(date) => setIssuedDate(date)}
                        slotProps={{ textField: { size: 'small' } }}
                        fullWidth
                        className="customDatePicker"
                        renderInput={(props) => (
                          <TextField required {...props} />
                        )}
                      />
                    </Stack>
                  </LocalizationProvider>
                </Grid>

              </Grid>
            </Grid>

            <Grid item xs={12} lg={11} xl={10} mt={5} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center" >
                  <CustomTableContainer colors={colors}>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Material Code</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Description</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Requested</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', minWidth: '100px' }}>UOM</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Stock Available</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Safety Stock</TableCell>
                            {editIssueIndentID == 0 ?
                              <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Issued</TableCell>
                              : <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Quantity Issued</TableCell>}

                            {/* <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>In Trasit</TableCell> */}
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Quantity to Issue</TableCell>
                            <TableCell style={{ fontSize: 14, padding: 10, textAlign: 'center' }}>Safety Stock Status</TableCell>
                            {/* <TableCell style={{ fontSize: 14, padding: 10, textAlign: 'center' }}>Safety Stock</TableCell>
 <TableCell style={{ fontSize: 14, padding: 10, textAlign: 'center' }}>Re-order Level</TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tableRows.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell style={{ size: "small", width: "300px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  disabled
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'center',
                                    },
                                  }}
                                  variant="outlined"
                                  type="text"
                                  value={`${row.material_code} `}
                                />
                              </TableCell>
                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'center',
                                    },
                                  }}
                                  value={row.material_description}
                                  variant="outlined"
                                  disabled
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                                <TextField
                                  fullWidth
                                  disabled
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  variant="outlined"
                                  type="number"
                                  value={row.quantity_approved}

                                />
                              </TableCell>
                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}> <TextField
                                fullWidth
                                disabled
                                size="small"
                                sx={{
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                  },
                                  '& .MuiInputBase-input': {
                                    padding: '8px',
                                    textAlign: 'center',
                                  },
                                }}
                                variant="outlined"
                                type="text"
                                value={row.material_uom}

                              />
                              </TableCell>

                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  disabled
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  variant="outlined"
                                  type="number"
                                  value={row.quantity_available}
                                />
                              </TableCell>
                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  disabled
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  variant="outlined"
                                  type="number"
                                  value={row.safety_stock}
                                />
                              </TableCell>
                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  disabled
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  variant="outlined"
                                  type="number"
                                  value={row.quantity_issued}
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  variant="outlined"
                                  type="number"
                                  value={row.quantity_to_issue}
                                  onChange={(e) => handleQuantityChange(index, e.target.value)}
                                />
                              </TableCell>

                              <TableCell style={{ fontSize: 12, padding: 0, border: '1px solid black', textAlign: 'center', fontWeight: 'bold', color: row.stock_status === 'CRITICAL – BELOW SAFETY STOCK' ? 'red' : row.stock_status === 'WARNING – REORDER REQUIRED' ? 'orange' : 'green' }}>
                                {row.stock_status}
                              </TableCell>
                              {/* <TableCell style={{ fontSize: 12, padding: 0, border: '1px solid black', textAlign: 'center', fontWeight: 'bold', }}>
  {row.safety_stock}
</TableCell>
 <TableCell style={{ fontSize: 12, padding: 0, border: '1px solid black', textAlign: 'center', fontWeight: 'bold', }}>
  {row.reorder_level}
</TableCell> */}


                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CustomTableContainer>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} lg={12} xl={12} mt={1} padding={2} >
              <Box padding={1} sx={{
                display: 'flex',
                alignItems: 'center',
                borderColor: 'divider',
                borderRadius: 2,
                color: 'text.secondary', '& svg': { m: 1, },
              }} >
                <Grid container spacing={0}>
                  <Grid item xs={6} lg={6.4} xl={6} marginRight={1}>
                    <Typography variant="h5" fontWeight="bold">Notes (For Internal Use) </Typography>
                    <Grid item xs={12} lg={12} xl={10}>
                      <TextField
                        id="outlined-multiline-static"
                        value={customerNotes}
                        onChange={(e) => setCustomerNotes(e.target.value)}
                        placeholder="Enter the issuer notes , will appear the issue indent."
                        multiline
                        rows={4}
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

          </Grid>
        </Box>

        <Grid container>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
            <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
              <Toolbar>
                <Button size="small" variant="contained" color="secondary" onClick={handleSaveAndDraft} startIcon={<SaveAltIcon />} disabled={saveDisabled} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save Issued</Button>
                <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>

                {viewPurchaseIndent && (
                  <Button size="small" onClick={handleCreatePurchaseIndent} variant="outlined" color="secondary" startIcon={<CreateIcon />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Create Purchase Indent</Button>
                )}

              </Toolbar>
            </Box>
          </Grid>
        </Grid>



      </Box>)}

    {viewPurchaseIndentPage && (
      <AddNewPurchaseIndent handlecallback={handlecallback} editIssueIndentID={0} idDepartment={selectedDepartmentID} idRequestIndent={selectedRequestIndentNumberListID} />
    )}

  </>)
}
export default AddNewIssue;